import {
  initialState,
  Actions,
  State,
  GET_CONFIRMATION,
  GET_CONFIRMATION_ERROR,
  GET_CONFIRMATION_SUCCESS,
  RESET_UPDATE_CONFIRMATION,
  UPDATE_CONFIRMATION,
  UPDATE_CONFIRMATION_ERROR,
  UPDATE_CONFIRMATION_SUCCESS,
} from "../types/confirmation";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_CONFIRMATION:
      return {
        ...state,
        confirmation: {
          data: null,
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case GET_CONFIRMATION_SUCCESS:
      return {
        ...state,
        confirmation: {
          data: action.payload,
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case GET_CONFIRMATION_ERROR:
      return {
        ...state,
        confirmation: {
          data: null,
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    /* case RESET_UPDATE_CONFIRMATION:
      return {
        ...state,
        confirmation: initialState.confirmation,
      }; */
    case UPDATE_CONFIRMATION:
      return {
        ...state,
        updateConfirmation: {
          states: {
            loading: true,
            error: false,
            success: false,
          },
        },
      };
    case UPDATE_CONFIRMATION_SUCCESS:
      return {
        ...state,
        updateConfirmation: {
          states: {
            loading: false,
            error: false,
            success: true,
          },
        },
      };
    case UPDATE_CONFIRMATION_ERROR:
      return {
        ...state,
        updateConfirmation: {
          states: {
            loading: false,
            error: action.payload,
            success: false,
          },
        },
      };
    case RESET_UPDATE_CONFIRMATION:
      return {
        ...state,
        updateConfirmation: initialState.updateConfirmation,
      };
    default:
      return state;
  }
};

export default reducers;
